import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";

export const IAddNewInvestmentMessagesScheme = z.object({
  contentTitle: themeScheme.MessageScheme.default("<b>Dodaj inwestycję</b> i zarządzaj nią na wielu płaszczyznach z pomocą Unimax"),
  contentText1: themeScheme.MessageScheme.default("Indywidualne <b>ceny dla inwestycji</b>"),
  contentText2: themeScheme.MessageScheme.default("<b>Rekomendacje produktowe</b> i <b>promocyjne</b> pasujące do twojej inwestycji"),
  contentText3: themeScheme.MessageScheme.default("<b>Dostawy bezpośrednio</b> na wskazaną budowę"),
  contentText4: themeScheme.MessageScheme.default("<b>Statystyki</b> i <b>raporty</b> odnośnie Twoich zakupów w Unimax"),
  contentText5: themeScheme.MessageScheme.default("Dokumentacja, <b>faktury</b> i <b>rozliczenia</b> w kontekście każdej inwestycji"),
  stepOneTitle: themeScheme.MessageScheme.default("Dodaj inwestycję"),
  investmentNameLabel: themeScheme.MessageScheme.default("Nazwa inwestycji"),
  investmentTypeTitle: themeScheme.MessageScheme.default("Typ inwestycji"),
  nextButton: themeScheme.MessageScheme.default("Dalej"),
  investmentType1: themeScheme.MessageScheme.default("Domek"),
  investmentType2: themeScheme.MessageScheme.default("Mieszkaniówka"),
  investmentType3: themeScheme.MessageScheme.default("Obiekt komercyjny np.biurowiec, szkoła"),
  investmentType4: themeScheme.MessageScheme.default("Obiekt przemysłowy np. hala magazynowa, produkcyjna"),
  investmentStageTitle: themeScheme.MessageScheme.default("Etap inwestycji"),
  investmentStage1: themeScheme.MessageScheme.default("Przetarg / Ofertowanie"),
  investmentStage2: themeScheme.MessageScheme.default("Realizacja"),
  stepTwoTitle: themeScheme.MessageScheme.default("Uzupełnij adres dla"),
  stepTwoDescription: themeScheme.MessageScheme.default("Podaj adres swojej inwestycji, aby otrzymywać dostawy produktów wprost na Twoją budowę. Dane opcjonalnie."),
  addressLabel: themeScheme.MessageScheme.default("Ulica"),
  houseNoLabel: themeScheme.MessageScheme.default("Bud."),
  apartmentNoLabel: themeScheme.MessageScheme.default("Lok."),
  cityLabel: themeScheme.MessageScheme.default("Miejscowość"),
  postalCodeLabel: themeScheme.MessageScheme.default("Kod pocztowy"),
  submitButton: themeScheme.MessageScheme.default("Zapisz"),
  contactPersonsLabel: themeScheme.MessageScheme.default("Osoba kontaktowa dla dostaw"),
  successTitle: themeScheme.MessageScheme.default("Gratulacje!"),
  successDescription: themeScheme.MessageScheme.default("Inwestycja #investmentName została dodana"),
  successButtonLabel_1: themeScheme.MessageScheme.default("Przejdź do strony głównej"),
  successButtonLabel_2: themeScheme.MessageScheme.default("Przejdź do karty inwestycji"),
  successLink_1: themeScheme.UrlScheme.default("/"),
  successLink_2: themeScheme.UrlScheme.default("/"),
});

export const IAddNewInvestmentSettingsScheme = z.object({
  boxMainColor: themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  contentTitleTypo: themeScheme.TypoIdScheme.default("typo$$10").catch("typo$$10"),
  contentTextTypo: themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  mainTitleTypo: themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  investmentFormInput: themeScheme.InputIdScheme.default("input$$1").catch("input$$1"),
  investmentFormTitleTypo: themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  buttonStyle: themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),
  optionsTextTypo: themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  errorTextColor: themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  errorTextBackground: themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  optionActiveBackground: themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  stepTwoDescriptionTypo: themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  multiSelectTextTypo: themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  secondaryButtonStyle: themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),
});

const zipCodeRegex = /(^\d{5}$)|(^\d{9}$)|(^\d{2}-\d{3}$)/;


export const addInvestmentSchema = z.object({
  name: z
    .string({ required_error: "Pole nie może być puste" })
    .min(1, { message: "Pole nie może być puste" })
    .max(350, { message: "Maksymalna liczba znaków to 350" }),
  type: z
    .string({ required_error: "Wybierz przynajmniej jedną z opcji" })
    .min(1, { message: "Wybierz przynajmniej jedną z opcji" }),
  stage: z
    .string({ required_error: "Wybierz przynajmniej jedną z opcji" })
    .min(1, { message: "Wybierz przynajmniej jedną z opcji" }),
  street: z.string().max(60, { message: "Maksymalna liczba znaków to 60" }).optional(),
  houseNo: z.string().optional(),
  apartmentNo: z.string().optional(),
  postalCode: z.string().length(6, {
    message: "Podaj poprawny kod pocztowy",
  })
    .refine((value) => {
      return value !== "" && zipCodeRegex.test(value)
    }, { message: "Podaj poprawny kod pocztowy" }).optional(),
  city: z.string().max(30, { message: "Maksymalna liczba znaków to 30" }).optional(),
  addressLocationImage: z.custom<File>((val) => val instanceof Blob).optional(),
  contactPersonsIds: z.array(z.object({ id: z.string() })).optional(),
});

